import { App } from "App"
import { initi18n } from "lib/i18n/init"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

initi18n()

const container = document.getElementById("root")
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
